class AycanPasswordBar extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-pw-toggle]');
    this.panel = this.querySelector('[data-pw-panel]');
    if (!this.toggle || !this.panel) return;

    this.toggle.addEventListener('click', () => this.toggleOpen());

    if (this.querySelector('input[aria-invalid="true"]')) {
      this.open();
    }
  }

  toggleOpen() {
    if (this.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    const input = this.querySelector('.aycan-pw-bar__input');
    if (input) {
      window.requestAnimationFrame(() => input.focus());
    }
  }

  close() {
    this.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('aycan-password-bar', AycanPasswordBar);

(function initLaunchCountdown() {
  const root = document.querySelector('[data-launch-countdown]');
  if (!root) return;

  const iso = root.dataset.launch;
  if (!iso) {
    root.hidden = true;
    return;
  }

  const target = new Date(iso);
  if (Number.isNaN(target.getTime())) {
    root.hidden = true;
    return;
  }

  const nums = {
    days: root.querySelector('[data-unit="days"]'),
    hours: root.querySelector('[data-unit="hours"]'),
    minutes: root.querySelector('[data-unit="minutes"]'),
    seconds: root.querySelector('[data-unit="seconds"]')
  };
  const done = root.closest('.aycan-open__card')?.querySelector('[data-countdown-done]');

  const pad = (n) => String(n).padStart(2, '0');

  const tick = () => {
    const diff = target.getTime() - Date.now();
    if (diff <= 0) {
      root.hidden = true;
      if (done) done.hidden = false;
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (nums.days) nums.days.textContent = pad(days);
    if (nums.hours) nums.hours.textContent = pad(hours);
    if (nums.minutes) nums.minutes.textContent = pad(minutes);
    if (nums.seconds) nums.seconds.textContent = pad(seconds);
  };

  tick();
  window.setInterval(tick, 1000);
})();
